<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    v-loading="createProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create Button Layout</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="createOperation">
            Create
          </el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
            >Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <el-input v-model="createForm.name" placeholder="Name">
        <template slot="prefix">Name</template>
      </el-input>
      <div class="inline-form-group">
        <el-tag class="mb-2 mt-5" type="warning">
          <i class="el-icon-warning" style="margin-right: 4px;"></i>
          Start Key must be &gt;&equals; 1 and End Key must be &gt; Start Key.
        </el-tag>
      </div>
      <div class="inline-form-group">
        <el-col :span="11">
          <el-input
            v-model.number="createForm.start"
            type="number"
            placeholder="Start Key"
          >
            <template slot="prefix">Start Key</template>
          </el-input>
        </el-col>
        <el-col :span="2"> </el-col>
        <el-col :span="11">
          <el-input
            v-model.number="createForm.end"
            type="number"
            placeholder="End Key"
          >
            <template slot="prefix">End Key</template>
          </el-input>
        </el-col>
      </div>
      <key-assignments
        :validKeyRange="validKeyRange"
        :startKey="createForm.start"
        :endKey="createForm.end"
        @keysSelected="onKeysSelection"
      />
    </el-form>
  </el-dialog>
</template>

<script>
import KeyAssignments from "./keyAssignments.vue";

export default {
  name: "ButtonLayoutsCreateForm",

  props: {
    createVisible: { required: true },
    clearFormFields: { required: true },
    createProcessing: { required: true }
  },

  components: {
    KeyAssignments
  },

  data() {
    return {
      createForm: {
        tenantId: null,
        name: "",
        start: "",
        end: "",
        keys: []
      }
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    validKeyRange() {
      return (
        +this.createForm.start >= 1 &&
        +this.createForm.end > +this.createForm.start
      );
    }
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    }
  },

  methods: {
    onKeysSelection(keys) {
      this.createForm.keys = keys.map(({ type, name, number }) => ({
        type,
        name,
        number
      }));
    },

    createOperation() {
      if (!this.validKeyRange) {
        this.$notify({
          title: "Invalid Key Range",
          message: "Start Key must be >= 1 and End Key must be > Start Key.",
          type: "error"
        });
        return;
      }
      this.createForm.tenantId = this.selectedTenant.id;
      const createBody = { ...this.createForm };
      this.$emit("createOperation", createBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "create");
    },

    clearFields() {
      this.createForm = {
        tenantId: null,
        name: "",
        start: "",
        end: "",
        keys: []
      };
    }
  }
};
</script>
